(() => {
  const format = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:document.body.dataset.currency || 'INR'}).format(cents/100); }
    catch (_) { return '₹'+(cents/100).toFixed(2); }
  };
  let activeSound;
  const stopSound = () => {
    if (!activeSound) return;
    const {audio, button} = activeSound;
    activeSound = null;
    audio.pause();
    if (audio.readyState > 0) audio.currentTime = 0;
    button.classList.remove('is-playing');
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', button.dataset.soundLabel);
    button.title = button.dataset.soundLabel;
  };
  const initializeSounds = section => {
    if (section.dataset.toySoundsReady) return;
    section.dataset.toySoundsReady = 'true';
    const audio = section.querySelector('[data-toy-audio]');
    const status = section.querySelector('[data-toy-sound-status]');
    if (!audio || !status) return;
    const failed = () => {
      if (activeSound?.audio !== audio) return;
      stopSound();
      status.textContent = status.dataset.errorMessage;
    };
    const playNext = session => {
      if (activeSound !== session) return;
      const src = session.queue.shift();
      if (!src) { stopSound(); return; }
      audio.src = src;
      audio.volume = .65;
      audio.play().catch(() => {
        if (activeSound === session) failed();
      });
    };
    audio.addEventListener('ended', () => {
      if (activeSound?.audio === audio) playNext(activeSound);
    });
    audio.addEventListener('error', failed);
    section.addEventListener('click', event => {
      const button = event.target.closest('[data-toy-sound]');
      if (!button || !section.contains(button)) return;
      const wasPlaying = activeSound?.button === button;
      stopSound();
      status.textContent = '';
      if (wasPlaying) return;
      const pet = button.dataset.toySound;
      const queue = pet === 'cats' ? [audio.dataset.catSrc] : pet === 'dogs' ? [audio.dataset.dogSrc] : [audio.dataset.dogSrc, audio.dataset.catSrc];
      const session = {audio, button, queue, section};
      activeSound = session;
      button.classList.add('is-playing');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', button.dataset.stopLabel);
      button.title = button.dataset.stopLabel;
      playNext(session);
    });
  };
  document.querySelectorAll('[data-toy-showcase]').forEach(initializeSounds);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-toy-showcase]').forEach(initializeSounds);
  });
  document.addEventListener('shopify:section:unload', event => {
    if (activeSound && event.target.contains(activeSound.section)) stopSound();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopSound();
  });
  document.querySelectorAll('[data-toy-showcase] [data-toy-card]').forEach(card => {
    card.querySelectorAll('[data-toy-choice]').forEach(choice => choice.addEventListener('click', () => {
      card.querySelectorAll('[data-toy-choice]').forEach(button => { const active = button === choice; button.classList.toggle('is-active',active); button.setAttribute('aria-pressed',String(active)); });
      card.querySelector('input[name="id"]').value = choice.dataset.id;
      const price = Number(choice.dataset.price), compare = Number(choice.dataset.compare);
      card.querySelector('[data-toy-price]').textContent = format(price);
      const compareElement = card.querySelector('[data-toy-compare]');
      compareElement.hidden = !(compare > price);
      if (compare > price) compareElement.textContent = format(compare);
      const sale = card.querySelector('[data-toy-sale]');
      if (sale) { sale.hidden = !(compare > price); if (compare > price) sale.textContent = Math.floor((compare-price)*100/compare)+'% '+(sale.dataset.saleSuffix || 'off'); }
      if (choice.dataset.image) {
        const image = card.querySelector('.paw-toy-card__image');
        if (image) { image.removeAttribute('srcset'); image.src = choice.dataset.image; if (choice.dataset.alt) image.alt = choice.dataset.alt; }
      }
    }));
  });
  const initializeGrid = section => {
    if (section.dataset.toyGridReady) return;
    section.dataset.toyGridReady = 'true';
    const grid = section.querySelector('[data-toy-grid]');
    if (!grid) return;
    const cards = [...section.querySelectorAll('[data-toy-card]')];
    const groupButtons = [...section.querySelectorAll('[data-toy-group-filter]')];
    const empty = section.querySelector('[data-toy-empty]');
    const status = section.querySelector('[data-toy-status]');
    const prev = section.querySelector('[data-toy-prev]');
    const next = section.querySelector('[data-toy-next]');
    let group = 'all';
    const updateArrows = () => {
      const hidden = grid.hidden || grid.scrollWidth - grid.clientWidth < 2;
      if (prev) prev.hidden = hidden;
      if (next) next.hidden = hidden;
    };
    const move = direction => {
      const remaining = grid.scrollWidth - grid.clientWidth;
      if (grid.hidden || remaining < 2) return;
      const rtl = getComputedStyle(grid).direction === 'rtl';
      const sign = rtl ? -1 : 1;
      const position = Math.abs(grid.scrollLeft);
      const card = cards.find(item => !item.hidden);
      const gap = parseFloat(getComputedStyle(grid).columnGap) || 16;
      const distance = card ? card.getBoundingClientRect().width + gap : grid.clientWidth;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (direction < 0 && position <= 2) {
        grid.scrollTo({left: sign * remaining, behavior});
      } else if (direction > 0 && position >= remaining - 2) {
        grid.scrollTo({left: 0, behavior});
      } else {
        grid.scrollBy({left: sign * direction * distance * (window.innerWidth < 750 ? 1 : 2), behavior});
      }
    };
    const render = () => {
      groupButtons.forEach(button => {
        button.disabled = button.dataset.toyGroupFilter !== 'all' && !cards.some(card => card.dataset.toyGroup === button.dataset.toyGroupFilter);
      });
      if (group !== 'all' && groupButtons.find(button => button.dataset.toyGroupFilter === group)?.disabled) group = 'all';
      const matching = cards.filter(card => group === 'all' || card.dataset.toyGroup === group);
      const visible = new Set(matching);
      cards.forEach(card => { card.hidden = !visible.has(card); });
      empty.hidden = matching.length > 0;
      grid.hidden = matching.length === 0;
      if (status) status.textContent = matching.length ? matching.length + ' toys available in the slider.' : 'No toys match these filters.';
      groupButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.toyGroupFilter === group)));
      grid.scrollTo({left: 0, behavior: 'auto'});
      updateArrows();
    };
    groupButtons.forEach(button => button.addEventListener('click', () => { if (button.disabled) return; group = button.dataset.toyGroupFilter; render(); }));
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    const observer = new ResizeObserver(updateArrows);
    observer.observe(grid);
    render();
    const unload = event => {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  };
  document.querySelectorAll('[data-toy-showcase]').forEach(initializeGrid);
  document.addEventListener('shopify:section:load', event => {
    const section = event.target.querySelector('[data-toy-showcase]');
    if (section) initializeGrid(section);
  });
})();
